import React, { useMemo } from 'react';
import { WppSelect, WppListItem } from '@wppopen/components-library-react';
import { IDropdownComponent, normalizeString } from 'utils';
import { Main, BottomTooltip } from './DropdownComponentStyles';

export const DropdownComponent = ({
    value,
    handleChange,
    keyProp,
    placeholder,
    message,
    messageType,
    inputDisabled,
    minItemSelected = 1,
    maxItemSelected = 10,
    isSingleSelection = false,
    selectionData,
    containerWidth = '165px',
    dropdownWidth = '268px',
    tooltip,
    label = '',
    required = true,
    icon = '',
    iconDescription = '',
    allSelectedText = 'All selected',
    wppSize,
    dataTestId,
}: IDropdownComponent) => {
    const handlerSelect = (e: any) => {
        handleChange(keyProp, e.detail.value, isSingleSelection);
    };
    const ReadySelection = useMemo(() => {
        return selectionData[keyProp]?.map((option: any) => {
            const minBlockedItems =
                value?.length === minItemSelected && value.includes(option.value);
            const maxBlockedItems =
                value?.length === maxItemSelected && value.includes(option.value);
            return (
                <WppListItem
                    key={option.label}
                    value={option.value}
                    multiple={!isSingleSelection}
                    id={option.label}
                    disabled={!isSingleSelection && (minBlockedItems || maxBlockedItems)}
                    data-testid={`${dataTestId}.DROPDOWN.${normalizeString(option.label)}`}
                >
                    <p slot="label">{option.label}</p>
                </WppListItem>
            );
        });
    }, [
        keyProp,
        minItemSelected,
        maxItemSelected,
        value,
        selectionData,
        isSingleSelection,
        dataTestId,
    ]);

    return (
        <Main data-testid={dataTestId}>
            <WppSelect
                key={keyProp}
                onWppChange={handlerSelect}
                placeholder={placeholder}
                message={message}
                messageType={messageType}
                value={value}
                type={isSingleSelection ? 'single' : 'multiple'}
                id={keyProp}
                size={wppSize}
                dropdownPosition="absolute"
                dropdownWidth={dropdownWidth}
                disabled={inputDisabled}
                className="MultiSelect"
                style={{ width: containerWidth }}
                labelConfig={{
                    text: label,
                    icon: icon,
                    description: iconDescription,
                }}
                locales={{
                    allSelectedText,
                }}
                required={required}
                data-testid={`${dataTestId}.DROPDOWN`}
            >
                {ReadySelection}
            </WppSelect>
            <BottomTooltip type="xs-strong" isVisible={Boolean(tooltip)}>
                {tooltip}
            </BottomTooltip>
        </Main>
    );
};
